import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetExtraService } from "./useGetExtraService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ExtraServiceEntity } from "../../Objects/ExtraService/ExtraServiceEntity"
import { useTranslation } from "react-i18next"

export const useRemoveExtraService = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetExtraService } = useGetExtraService()

  const handleRemove = async (extraService: ExtraServiceEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.EXTRA_SERVICE.DELETE}/${extraService.id}`)

      if (response.success) {
        await handleGetExtraService(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
